import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';

const Analytics = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Detailed Analytics</h1>
        <p className="text-lg text-slate-600 mb-8">Deep insights into platform performance</p>

        <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center">
          <p className="text-slate-600 mb-4">Advanced analytics would include charts, trends, cohort analysis, and more detailed metrics.</p>
          <Button
            onClick={() => navigate('/admin/overview')}
            variant="secondary"
            className="rounded-full"
          >
            View Overview Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
